"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchBar = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const material_1 = require("@mui/material");
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const Search_1 = __importDefault(require("@mui/icons-material/Search"));
const react_router_dom_1 = require("react-router-dom");
const useDebounce_1 = __importDefault(require("../../../common/helpers/Hooks/useDebounce"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const SearchBarWrapper = styled_components_1.default.div `
  .MuiAppBar-root {
    background: ${(props) => props.theme.palette ? props.theme.palette.colorAppBar.main : "#000"};
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);
  }

  .MuiTypography-root {
    color: ${(props) => props.theme.palette ? props.theme.palette.colorOnAppBar.main : "#000"};
  }
`;
const SearchInputWrapper = styled_components_1.default.div `
  height: 64px;
  background: #ffffff;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);
  position: relative;
  display: flex;

  .MuiSvgIcon-root {
    position: initial;
    text-align: center;
  }

  .MuiInputBase-adornedStart {
    &:before,
    &:after {
      border-bottom: none !important;
    }
  }

  input {
    padding-left: 20px;
  }

  .MuiFormControl-root {
    width: 85%;
    height: 100%;
    justify-content: center;
  }

  .MuiInputBase-root {
    height: 100%;
    background: rgba(0, 0, 0, 0.06);
    border-radius: 0px;

    &:hover {
      background: rgba(0, 0, 0, 0.09);
    }
  }

  .MuiOutlinedInput-notchedOutline {
    border: none;
  }
`;
const CancelButton = styled_components_1.default.div `
  flex-basis: 15%;
  padding: 12px;
  justify-content: center;
  display: flex;
  align-content: center;
  align-items: center;
  color: rgba(0, 0, 0, 0.87);
  cursor: pointer;
`;
const SearchBar = (props) => {
    const { searchProducts, history, baseUrl, onInputFocus, onClose } = props;
    const [showInput, setShowInput] = (0, react_1.useState)(false);
    const [searchTerm, setSearchTerm] = (0, react_1.useState)("");
    const debouncedSearchTerm = (0, useDebounce_1.default)(searchTerm, 400);
    const hideSearchInput = () => {
        setSearchTerm("");
        setShowInput(false);
        onClose();
    };
    const clearSearchInput = () => {
        setSearchTerm("");
    };
    const showSearchInput = () => {
        setShowInput(true);
        onInputFocus();
    };
    const goToOverview = () => {
        history.push(baseUrl);
    };
    (0, react_1.useEffect)(() => {
        searchProducts(debouncedSearchTerm);
    }, [debouncedSearchTerm]);
    return (react_1.default.createElement(SearchBarWrapper, null, showInput ? (react_1.default.createElement(material_1.AppBar, { position: "fixed" },
        react_1.default.createElement(SearchInputWrapper, { className: "search-input" },
            react_1.default.createElement(material_1.TextField, { id: "search", fullWidth: true, autoFocus: true, role: "searchbox", value: searchTerm, onChange: (e) => setSearchTerm(e.target.value), variant: "outlined", InputProps: {
                    startAdornment: (react_1.default.createElement(material_1.InputAdornment, { position: "start" },
                        react_1.default.createElement(Search_1.default, null))),
                    endAdornment: (react_1.default.createElement(react_1.default.Fragment, null, searchTerm.length > 0 && (react_1.default.createElement(material_1.InputAdornment, { position: "end" },
                        react_1.default.createElement(material_1.IconButton, { "aria-label": "clear search input", onClick: clearSearchInput, onMouseDown: clearSearchInput },
                            react_1.default.createElement(Close_1.default, null)))))),
                } }),
            react_1.default.createElement(CancelButton, { onClick: hideSearchInput }, i18n_js_1.default.t("cancel"))))) : (react_1.default.createElement(material_1.AppBar, { position: "fixed" },
        react_1.default.createElement(material_1.Toolbar, null,
            react_1.default.createElement(material_1.IconButton, { size: "large", edge: "start", "data-testid": "close-button", "aria-label": "close button", onClick: goToOverview },
                react_1.default.createElement(Close_1.default, { color: "colorOnAppBar" })),
            react_1.default.createElement(material_1.Typography, { noWrap: true, component: "div", sx: {
                    flexGrow: 1,
                    textAlign: { xs: "center" },
                    display: { xs: "block" },
                }, className: "page-title", "data-testid": "headline" }, "Was suchen Sie?"),
            react_1.default.createElement(material_1.IconButton, { size: "large", edge: "end", "data-testid": "search-icon", "aria-label": "search icon", onClick: showSearchInput },
                react_1.default.createElement(Search_1.default, { color: "colorOnAppBar" })))))));
};
exports.SearchBar = SearchBar;
const mapStoreToProps = (store) => ({
    baseUrl: store.getValue("baseUrl"),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(exports.SearchBar));
